import { createAlert } from '../api';
import { useDataMutation } from '@packages/dataQuery';
import { CustomObject } from '../../../../../types';
import { PublicJobCreateAlertRequestData, PublicJobCreateAlertResponseData } from '../types';

export const usePublicJobSubscriptionSubmitMutation = () => {
	return useDataMutation<PublicJobCreateAlertResponseData, CustomObject, PublicJobCreateAlertRequestData>(
		createAlert,
	);
};
